import { render, staticRenderFns } from "./admin-group-show.vue?vue&type=template&id=6d6e5a8a&scoped=true"
import script from "./admin-group-show.vue?vue&type=script&lang=js"
export * from "./admin-group-show.vue?vue&type=script&lang=js"
import style0 from "./admin-group-show.vue?vue&type=style&index=0&id=6d6e5a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6e5a8a",
  null
  
)

export default component.exports